<pa-loader *ngIf="loadingStatus$ | async"></pa-loader>
<nz-layout class="container-fluid px-0 h-100">
  <!--  Başarılı işlemde yani ilk açılışta çalışıcak web ve mobil header-->
  <pa-header *ngIf="(showHeader$ | async) && show" class="desktop-only-header" [sdkInitTexts]="sdkInitTexts"
             [amount]="amount"
             [returnUrl]="returnUrl"
             [deadLine]="deadline"
             [brandIcon]="brandIcon"
             [loginWebSdk]="loginWebSdk"
             [getResultUrl]="getResultUrl"></pa-header>
  <pa-mobile-header *ngIf="(showHeader$ | async) && show" class="mobile-only-header" [sdkInitTexts]="sdkInitTexts"
                    [amount]="amount"
                    [returnUrl]="returnUrl"
                    [deadLine]="deadline"
                    [brandIcon]="brandIcon"></pa-mobile-header>

  <!-- Sayfa Yenilemelerinde çalışıcak web ve mobil header-->
  <pa-header *ngIf="show && sessionInfoServiceRequestCheck" class="desktop-only-header" [sdkInitTexts]="sdkInitTexts"
             [amount]="amount"
             [returnUrl]="returnUrl"
             [deadLine]="deadline"
             [brandIcon]="brandIcon"></pa-header>

  <pa-mobile-header *ngIf="show && sessionInfoServiceRequestCheck" class="mobile-only-header"
                    [sdkInitTexts]="sdkInitTexts"
                    [amount]="amount"
                    [returnUrl]="returnUrl"
                    [deadLine]="deadline"
                    [brandIcon]="brandIcon"></pa-mobile-header>

  <!--  Başarısız işlemde yani ilk açılışta çalışıcak web ve mobil header-->
  <pa-header *ngIf="showHeader$ && !show" class="desktop-only-header"></pa-header>
  <pa-mobile-header *ngIf="showHeader$ && !show" class="mobile-only-header"></pa-mobile-header>
  <nz-content class="container px-0">
    <router-outlet></router-outlet>
  </nz-content>
</nz-layout>
